import moment from 'moment'
import { StatsItem } from '../stats/stats-item'
import { memo } from 'react'
import { useAccountContext } from '../../contexts/account-context'
import { useRecoilValue } from 'recoil'
import { accountTotalProfitsState } from '../../states/profit-shares-state'
import { selectedAccountState } from '../../states/selected-account-id'
import { CurrencyOperations } from '../../utils/currency'

const Component = () => {
  const accountId = useAccountContext()
  const profitsTotal = useRecoilValue(accountTotalProfitsState(accountId || ''))
  const account = useRecoilValue(selectedAccountState)
  const calculated =
    CurrencyOperations.getValueIn('BUSD', 'CZK', profitsTotal) +
    (parseFloat(String(account?.totalDepositsValue)) || 0)

  return (
    <StatsItem
      title={'Value'}
      value={calculated || 0}
      prefix={'CZK'}
      extraInfo={`(Last update ${moment().fromNow()})`}
    />
  )
}

export const TotalValueStat = memo(Component)